module.exports = __webpack_public_path__ + "static/media/enabledFullIcon.09ee4b3e.svg";